import styled from '@emotion/styled';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { navigationService } from 'src/config/rootService';
import logoImg from 'src/public/img/mh-logo-text.svg';
import { Button } from '@modernhealth/vital-components';
import { color, font } from 'src/shared/styles/variables';
import ineligiblePageImage from 'src/shared/svg/marginalia-no-comments.svg';
import { config } from 'src/config/config';

const Container = styled.div({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
});
const ContentContainer = styled.div({
    textAlign: 'center',
    maxWidth: '500px',
    flexDirection: 'column',
});
const Title = styled.h1(
    {
        paddingTop: '16px',
        color: color.ebonyClay,
        lineHeight: '44px',
        marginBottom: '8px',
    },
    font.heavy(font.size.headerPlus),
);
const Subtitle = styled.h3(
    {
        color: color.blueBayoux,
        lineHeight: '24px',
        paddingBottom: '40px',
        marginBottom: 0,
    },
    font.book(font.size.medium),
);
const ButtonsRow = styled.div({
    display: 'flex',
    justifyContent: 'center',
});
const ButtonsContainer = styled.div({
    width: '260px',
});
const BrandImage = styled.img({
    marginLeft: 32,
    marginTop: 20,
    width: '15em',
    cursor: 'pointer',
    marginRight: 12,
});
const BlueText = styled.a({
    textDecoration: 'underline',
    color: color.royalBlue,
});

export const IneligiblePage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <BrandImage
                src={logoImg}
                onClick={() => {
                    window.location.href = config.modernHealthURL;
                }}
            />
            <Container>
                <ContentContainer>
                    <img src={ineligiblePageImage} alt="" />
                    <Title>{t('auth:ineligible_page.title')}</Title>
                    <Subtitle>
                        <Trans
                            t={t}
                            ns="auth"
                            i18nKey="auth:ineligible_page.subtitle"
                            components={{
                                a: <BlueText href="mailto:help@joinmodernhealth.com" />,
                            }}
                        />
                    </Subtitle>
                    <ButtonsRow>
                        <ButtonsContainer>
                            <Button
                                variant="primary"
                                onClick={() => navigationService.navigate('/')}
                                size="large"
                                fluid
                            >
                                {t('auth:ineligible_page.button')}
                            </Button>
                        </ButtonsContainer>
                    </ButtonsRow>
                </ContentContainer>
            </Container>
        </>
    );
};
